'use strict';
angular.module('controllers').directive('upload', function () {
	return {
		restrict: 'A',
		scope: false,
		transclude: false,
		link: function (scope, element, attr) {
			//console.log(attr.upload);
			element.bind('change', function () {
				if(attr.upload == 'file') {
					scope.modelData[attr.upload] = element[0].files[0];
				}
				if(attr.upload == 'files') {
					if (!angular.isUndefined(scope.files)) {
						var idElement = element[0].id;
						var idArray = idElement.split('_');
						var id = idArray[1];

						scope.files[id] = {'file': element[0].files[0]};
					}
				}

			});

		}
	};
});
